module.exports = require('./helpers/bundle-url').getBundleURL('lbB2N') + "apple_pay.911ee907.svg";